// import RepositoryFactory from "@/apis";
// const hoc = RepositoryFactory.hoc;
import medicalCancer from "../../apis/medicalCancer";

export default {
  createMedicalCancer({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await medicalCancer.createMedicalCancer(payload);
        // console.log(data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getMedicalCancer({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log(payload);
        const { data } = await medicalCancer.getMedicalCancer(payload);
        commit("SET_MEDICAL_CANCER", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  updateMedicalCancer({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log(payload);
        const { data } = await medicalCancer.updateMedicalCancer(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  deleteMedicalCancer({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log(payload);
        const { data } = await medicalCancer.deleteMedicalCancer(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
